import React, { useEffect, useState, useRef } from 'react'
import Box from '@mui/material/Box'


interface IProps {
  setWidth: (value: number) => void
}

const SliderBar = ({ setWidth }: IProps) => {
  const elementRef = useRef<HTMLDivElement>(null)

  const startResizing = (mouseDownEvent: any) => {
    const startX = mouseDownEvent.clientX
    const startWidth = elementRef.current?.parentElement?.getBoundingClientRect().width || 0
    const previewWidth = elementRef.current?.parentElement?.firstElementChild?.getBoundingClientRect().width || 0
  
    const doResize = (mouseMoveEvent: MouseEvent) => {
        const currentX = mouseMoveEvent.clientX
        const deltaX = currentX - startX
        setWidth(Math.round(((previewWidth + deltaX) / startWidth) * 100))
    };
  
    const stopResizing = () => {
        document.removeEventListener('mousemove', doResize)
        document.removeEventListener('mouseup', stopResizing)
    };
  
    document.addEventListener('mousemove', doResize)
    document.addEventListener('mouseup', stopResizing)
  }

  return (
    <Box
      ref={elementRef}
      onMouseDown={startResizing}
      style={{ 
        width: '1rem', 
        zIndex: 20, 
        transform: 'translateX(-.5rem)', 
        cursor: 'col-resize', 
        background: 'transparent' }}
    />
  )
}

export default SliderBar

